import { resolveMediaUrl, mediaFallback } from '../../utils/media'

export default function MediaImage({
  src,
  alt = '',
  fallbackIndex = 0,
  className = '',
  ...props
}) {
  const resolved = resolveMediaUrl(src, mediaFallback(fallbackIndex))

  return (
    <img
      src={resolved}
      alt={alt}
      className={className}
      onError={(e) => {
        const img = e.currentTarget
        const attempts = [
          mediaFallback(fallbackIndex),
          resolveMediaUrl(mediaFallback(fallbackIndex)),
        ].filter(Boolean)

        for (const attempt of attempts) {
          try {
            const nextUrl = new URL(attempt, window.location.origin).href
            if (img.src !== nextUrl) {
              img.src = attempt
              return
            }
          } catch {
            continue
          }
        }
      }}
      {...props}
    />
  )
}
